<template>
  <div style="width: 100%; height: 100%; overflow: hidden; position: relative" ref="homePageRef">
    <!-- <img style="width: 100%; height: 100%" src="~@/assets/images/home-bg.png" /> -->
    <div class="home-slogan-video">
      <div style="text-align: center">
        <img class="home-slogan" src="~@/assets/images/home-slogan1.png" />
      </div>
      <div style="text-align: center; margin-top: 2.4074rem">
        <img @touchstart="videoTouch" class="home-video" src="~@/assets/images/home-video.png" />
      </div>
    </div>
    <div class="home-circle-container">
      <img src="~@/assets/images/home-circle.png" class="home-circle" />
      <img src="~@/assets/images/home-circle-mask.png" class="home-circle-mask" />
    </div>

    <img src="~@/assets/images/home-logo.png" class="home-logo" />

    <div class="home-keyboard-container">
      <img src="~@/assets/images/home-light-1.png" class="light" />
      <img src="~@/assets/images/home-keyboard.png" class="home-keyboard default" />
    </div>

    <div class="home-gift-container">
      <img src="~@/assets/images/home-light-2.png" class="light" />
      <img src="~@/assets/images/home-gift.png" class="home-gift default" />
    </div>

    <div class="home-game-container">
      <img src="~@/assets/images/home-light-3.png" class="light" />
      <img src="~@/assets/images/home-game.png" class="home-game default" />
    </div>

    <div class="home-yaogan-container">
      <img src="~@/assets/images/home-light-4.png" class="light" />
      <img src="~@/assets/images/home-yaogan.png" class="home-yaogan default" />
    </div>
  </div>
  <videoDialog ref="videoDialogRef"></videoDialog>
</template>

<script setup>
import { onMounted, ref } from "vue";
import videoDialog from "../videoDialog.vue";
import { loadIntroPage } from "@/assets/js/preload";

const videoDialogRef = ref();
const videoTouch = () => {
  videoDialogRef.value?.show("//image-platform.leniugame.com/ln_website/ln_video4.mp4");
};

const homePageRef = ref();
onMounted(() => {
  // loadIntroPage();
});
const endHandle = () => {
  if (homePageRef.value) {
    console.log(4545);
    // homePageRef.value.querySelector(".home-keyboard").classList.add("end");
    // homePageRef.value.querySelector(".home-game").classList.add("end");
    // homePageRef.value.querySelector(".home-gift").classList.add("end");
    // homePageRef.value.querySelector(".home-yaogan").classList.add("end");
  }
};
defineExpose({
  endHandle,
});
</script>

<style lang="scss" scoped>
.home-slogan-video {
  position: absolute;
  left: 0;
  right: 0;
  top: 23.0556rem;
  z-index: 4;

  .home-slogan {
    width: 156.5741rem;
    margin-left: -27rem;
  }
  .home-video {
    width: 19.1667rem;
    height: 9.1667rem;
  }
}
.home-circle-container {
  position: absolute;
  top: 67.963rem;
  left: 0;
  width: 100rem;
  height: 80.0926rem;
  .home-circle {
    width: 100%;
    height: 100%;
  }
  .home-circle-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
  }
}

.home-logo {
  position: absolute;
  top: 43.2407rem;
  left: 14.6296rem;
  width: 70.463rem;
  height: 76.9444rem;
  z-index: 1;
  // animation: rKeyframes 0.6s;

  // @keyframes rKeyframes {
  //   0% {
  //     transform: rotate(0deg) scale(1);
  //   }
  //   10% {
  //     transform: rotate(15deg) scale(1.1);
  //   }
  //   20% {
  //     transform: rotate(0deg) scale(1);
  //   }
  //   30% {
  //     transform: rotate(-15deg) scale(0.9);
  //   }
  //   40% {
  //     transform: rotate(0deg) scale(1);
  //   }
  //   50% {
  //     transform: rotate(15deg) scale(1.1);
  //   }
  //   60% {
  //     transform: rotate(0deg) scale(1);
  //   }
  //   70% {
  //     transform: rotate(-15deg) scale(0.9);
  //   }
  //   80% {
  //     transform: rotate(0deg) scale(1);
  //   }
  //   90% {
  //     transform: rotate(15deg) scale(1.1);
  //   }
  //   100% {
  //     transform: rotate(0deg) scale(1.36);
  //   }
  // }
}

.home-keyboard-container {
  position: absolute;
  left: 0;
  top: 23.4259rem;
  z-index: 3;
  width: 62.6852rem;
  height: 87.3148rem;

  .light {
    width: 100%;
    height: 100%;
  }
  .home-keyboard {
    position: absolute;
    top: 29.537rem;
    left: -3.7037rem;
    z-index: 3;
    width: 22.1296rem;
    height: 16.3889rem;

    &.default {
      animation: mKeyframes 3s infinite;
    }
    &.start {
      animation: mKeyframes 3s infinite, keyboardKeyframes 0.7s linear;
    }
    &.end {
      animation: keyboardKeyframes 0.7s ease-out reverse;
    }
    @keyframes keyboardKeyframes {
      0% {
        // top: 44.6296rem;
        // left: 44.6296rem;
        left: 26.6667rem;
        top: 32.5rem;
        transform: scale(0);
      }
      2% {
        // top: 41.6667rem;
        // left: 42.5926rem;
      }
      60% {
        top: 18.5185rem;
        left: 18.5185rem;
      }
      100% {
        top: 29.537rem;
        left: -3.7037rem;
        transform: scale(1);
      }
    }
  }
}

.home-gift-container {
  position: absolute;
  top: 39.0741rem;
  right: 0;
  z-index: 3;
  width: 64.9074rem;
  height: 49.9074rem;

  .light {
    width: 100%;
    height: 100%;
  }
  .home-gift {
    position: absolute;
    top: 12.5926rem;
    right: 11.6667rem;
    z-index: 3;
    width: 11.9444rem;
    height: 14.1667rem;

    &.default {
      animation: mKeyframes 3s infinite;
    }

    &.start {
      animation: mKeyframes 3s infinite, giftKeyframes 0.7s linear;
    }
    &.end {
      animation: giftKeyframes 0.7s ease-out reverse;
    }
    @keyframes giftKeyframes {
      0% {
        top: 44.0741rem;
        right: 29.1667rem;
        transform: scale(0);
      }
      50% {
        top: 28.7963rem;
        // right: 1.8519rem;
        right: 2.8519rem;
      }
      70% {
        top: 19.0556rem;
        right: 1.9519rem;
      }
      75% {
        top: 18.0556rem;
        right: 1.8519rem;
      }
      80% {
        top: 17.0556rem;
        right: 1.5519rem;
      }
      100% {
        top: 12.5926rem;
        right: 11.6667rem;
        transform: scale(1);
      }
    }
  }
}

.home-game-container {
  position: absolute;
  top: 71.3889rem;
  left: 0;
  z-index: 3;
  width: 100rem;
  height: 123.7963rem;

  .light {
    width: 100%;
    height: 100%;
  }
  .home-game {
    position: absolute;
    top: 42.7778rem;
    left: 0.463rem;
    z-index: 4;
    width: 54.537rem;
    height: 48.9815rem;

    &.default {
      animation: mKeyframes 3s infinite;
    }

    &.start {
      animation: mKeyframes 3s infinite, gameKeyframes 0.7s linear;
    }
    &.end {
      animation: gameKeyframes 0.7s ease-out reverse;
    }
    @keyframes gameKeyframes {
      0% {
        // top: -25.8704rem;
        // left: 23.1481rem;
        top: -20.3889rem;
        left: 3.1481rem;
        transform: scale(0);
      }
      60% {
        top: 7.3148rem;
        left: -20.1852rem;
      }
      100% {
        top: 42.7778rem;
        left: 0.463rem;
        transform: scale(1);
      }
    }
  }
}

.home-yaogan-container {
  position: absolute;
  top: 46.9444rem;
  right: 0;
  z-index: 3;
  width: 100rem;
  height: 93.3333rem;

  .light {
    width: 100%;
    height: 100%;
  }
  .home-yaogan {
    position: absolute;
    top: 51.6667rem;
    right: 0;
    width: 21.5741rem;
    height: 26.9444rem;

    &.default {
      animation: mKeyframes 3s infinite;
    }

    &.start {
      animation: mKeyframes 3s infinite, yaoganKeyframes 0.7s linear;
    }
    &.end {
      animation: yaoganKeyframes 0.7s ease-out reverse;
    }
    @keyframes yaoganKeyframes {
      0% {
        // top: 19.8148rem;
        // right: 46.2963rem;
        transform: scale(0);
        top: 22.6667rem;
        right: 58.7037rem;
      }
      20% {
        top: 22.6667rem;
        right: 58.7037rem;
      }
      40% {
        top: 28.6667rem;
        right: 52.7037rem;
      }
      50% {
        top: 35.463rem;
        right: 45.0926rem;
      }
      65% {
        top: 42.463rem;
        right: 36rem;
      }
      75% {
        top: 46.7963rem;
        right: 27.037rem;
      }
      100% {
        top: 51.6667rem;
        right: 0;
        transform: scale(1);
      }
    }
  }
}

@keyframes mKeyframes {
  0% {
    transform: translateY(6%);
  }
  50% {
    transform: translateY(-6%);
  }
  100% {
    transform: translateY(6%);
  }
}
</style>